import React from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-surface">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div>
          <p className="font-mono text-sm text-text">{t("sidebar.name")}</p>
          <p className="text-sm text-prose leading-relaxed mt-1 max-w-xs">{t("footer.tagline")}</p>
        </div>

        <nav aria-label={t("footer.quickLinks")}>
          <p className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
            {t("footer.quickLinks")}
          </p>
          <ul className="flex flex-col gap-2 md:gap-2">
            <li>
              <Link to="/" className="inline-flex items-center min-h-[44px] md:min-h-0 text-sm text-muted hover:text-text transition">
                {t("nav.about")}
              </Link>
            </li>
            <li>
              <Link to="/services" className="inline-flex items-center min-h-[44px] md:min-h-0 text-sm text-muted hover:text-text transition">
                {t("nav.services")}
              </Link>
            </li>
            <li>
              <Link to="/works" className="inline-flex items-center min-h-[44px] md:min-h-0 text-sm text-muted hover:text-text transition">
                {t("nav.works")}
              </Link>
            </li>
            <li>
              <Link to="/contact" className="inline-flex items-center min-h-[44px] md:min-h-0 text-sm text-muted hover:text-text transition">
                {t("nav.contact")}
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <p className="font-mono text-xs uppercase tracking-wide text-muted mb-3">
            {t("footer.connect")}
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://github.com/SlickAF31"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="w-11 h-11 flex items-center justify-center rounded border border-border text-muted hover:text-cyan hover:border-cyan transition"
            >
              <FaGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/raul-cheveresan-9a21bb20b/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-11 h-11 flex items-center justify-center rounded border border-border text-muted hover:text-cyan hover:border-cyan transition"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-4">
          <p className="font-mono text-xs text-muted">
            © {year} {t("sidebar.name")} · {t("footer.buildLine")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
